import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { HowToPlayModal } from "./components/HowToPlayModal";
import { Home } from "./pages/Home";
import { Stats } from "./pages/Stats";
import { TimeMachine } from "./pages/TimeMachine";
import { Admin } from "./pages/Admin";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { TermsOfService } from "./pages/TermsOfService";
import { Footer } from "./components/Footer";
import { initGA, trackPageView } from "./lib/analytics";

function Shell() {
  const [howTo, setHowTo] = useState(false);
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");

  useEffect(() => { initGA(); }, []);
  useEffect(() => { trackPageView(loc.pathname); }, [loc.pathname]);

  return (
    <div className="min-h-screen film-grain vignette">
      {!isAdmin && <Navbar onHowToPlay={() => setHowTo(true)} />}
      <Routes>
        <Route path="/" element={<Home onHowToPlay={() => setHowTo(true)} />} />
        <Route path="/stats" element={<Stats />} />
        <Route path="/time-machine" element={<TimeMachine />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
      </Routes>
      <HowToPlayModal open={howTo} onOpenChange={setHowTo} />
      {!isAdmin && <Footer />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Shell />
      <Toaster theme="dark" position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
